__turbopack_context__.v({
  "section": "contact-section-module-scss-module__JenYkq__section",
  "section__address": "contact-section-module-scss-module__JenYkq__section__address",
  "section__contact": "contact-section-module-scss-module__JenYkq__section__contact",
  "section__logo": "contact-section-module-scss-module__JenYkq__section__logo",
  "section__logo-wrapper": "contact-section-module-scss-module__JenYkq__section__logo-wrapper",
  "section__phone": "contact-section-module-scss-module__JenYkq__section__phone",
  "section__title": "contact-section-module-scss-module__JenYkq__section__title",
});
